// components/gallery/PhotoViewer/styles.js
import styled from "styled-components";

export const ViewerOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(
		255,
		255,
		255,
		0.9
	); 
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	padding: ${(props) => props.theme.spacing.xl};
`;

export const ViewerContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	max-width: 1400px;
	margin: 0 auto;
`;

export const ViewerImage = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		max-width: 100%;
		max-height: calc(100vh - 100px);
		object-fit: contain;
		transition: transform 0.3s ease;
	}
`;

export const NavigationButton = styled.button`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	background: rgba(0, 0, 0, 0.1);
	border: none;
	color: ${(props) => props.theme.colors.text.primary};
	width: 48px;
	height: 48px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all ${(props) => props.theme.transitions.fast};
	z-index: 2;

	&:hover {
		background: ${(props) => props.theme.colors.primary.main};
		color: white;
	}

	&.prev {
		left: ${(props) => props.theme.spacing.xl};
	}

	&.next {
		right: ${(props) => props.theme.spacing.xl};
	}

	@media (max-width: ${(props) => props.theme.breakpoints.sm}) {
		width: 40px;
		height: 40px;
	}
`;

export const CloseButton = styled(NavigationButton)`
	top: ${(props) => props.theme.spacing.md};
	right: ${(props) => props.theme.spacing.md};
	transform: none;
	background: ${(props) => props.theme.colors.primary.light};
	color: white;

	&:hover {
		background: ${(props) => props.theme.colors.primary.main};
	}
`;
